import React, { useCallback } from 'react';
import { Typography } from '@hmsexp/component-library';
import useGenericDataWithAppliedFilters from '../../../../hooks/useGenericDataWithAppliedFilters';
import MultiFeatureCard from '../../Card/MultiOptionsCard/MultiFeatureCard';
import get from 'lodash/get';
import ReviewTopicPlot from '../../../../containers/Overview/components/OverviewComp/components/ReviewTopicPlot';
import { useHistory } from 'react-router-dom';
import { styles } from './style';
import {
  TOP_AND_BOTTOM_TOPICS_API_TAG,
  TOP_AND_BOTTOM_TOPICS_DATA_TAG,
  TOP_AND_BOTTOM_TOPICS_WIDGET_ID
} from '../constants';

const TopAndBottomTopics = props => {
  const { item, applied_filter_values } = props;

  const { data, loading, error } = useGenericDataWithAppliedFilters({
    id: TOP_AND_BOTTOM_TOPICS_WIDGET_ID,
    data_tag: TOP_AND_BOTTOM_TOPICS_DATA_TAG,
    apiResponseKey: TOP_AND_BOTTOM_TOPICS_API_TAG
  });
  const history = useHistory();
  const onTopicClick = useCallback(
    e => {
      const appliedFilterValues = { ...(applied_filter_values || {}), topics_filter: [[e]] };
      const stringified = encodeURIComponent(JSON.stringify(appliedFilterValues));
      history.push(`/dashboard/feedback?filters=${stringified}`);
    },
    [history, applied_filter_values]
  );
  const isNoData = !loading && (error || Object.keys(data || {}).length === 0);

  return (
    <MultiFeatureCard
      title={get(item, 'title', '')}
      subTitle={get(item, 'subTitle', '')}
      enableActionBtn={get(item, 'enableActionBtn', false)}
      enableSwitchTab={get(item, 'enableSwitchTab', false)}
      switchOptions={get(item, 'switchOptions', [])}
      loading={loading}
      style={{ childContainer: styles.childContainer }}
      isNoData={isNoData}
      renderContent={(activeSwitch, contentRef) => {
        return (
          <ReviewTopicPlot
            isLoading={loading}
            type={activeSwitch}
            onTopicClick={onTopicClick}
            widgetData={item}
            itemData={data || {}}
            contentRef={contentRef}
          />
        );
      }}
      renderFooter={() => (
        <Typography fontWeightType='regular' variant='button'>
          {get(item, 'footerText')}
        </Typography>
      )}
    />
  );
};
export default TopAndBottomTopics;
